import React from 'react';
import { Outlet } from 'react-router-dom';
// import bgImage from '@/assets/auth-bg.png';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      {/* Background Image */}
      {/* <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      /> */}

      {/* Yellow Overlay */}
      <div className="absolute inset-0 bg-yellow-500/70" />

      {/* Main Content */}
      <div className="relative flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-sm">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <footer className="relative bg-black/80 text-white text-xs py-3 px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2">
          <div>
            <strong>100% SAFE</strong> — Protected connection and encrypted data
          </div>

          <div className="text-center">
            <div>24x7 Support</div>
            <div className="space-x-2">
              <span className="underline cursor-pointer">Terms</span>
              <span className="underline cursor-pointer">Responsible Gaming</span>
            </div>
          </div>

          <div className="text-right">© {new Date().getFullYear()} All Rights Reserved</div>
        </div>
      </footer>
    </div>
  );
}
